import { ChatAction } from 'redux/db/util';
import ChoiceAction from '../../ChoiceAction';
import ConnectFigmaAction from '../actions/ConnectFigmaAction';
import ConnectGithubAction from '../actions/ConnectGithubAction';
import ReconnectFigmaAction from '../actions/ReconnectFigmaAction';
import DiscardChangesAction from '../actions/DiscardChangesAction';
import DownloadDsAction from '../actions/DownloadDsAction';
import ExportDsAiAction from '../actions/ExportDsAiAction';
import GenerateGalleryAction from '../actions/GenerateGalleryAction';
import NewChatAction from '../actions/NewChatAction';
import PublishAction from '../actions/PublishAction';
import RestoreVersionAction from '../actions/RestoreVersionAction';
import ShowAction from '../actions/ShowAction';
import SwitchToLatestAction from '../actions/SwitchToLatestAction';
import TryInProjectAction from '../actions/TryInProjectAction';

interface Props {
	action: ChatAction;
}

const DsActionCard = ({ action }: Props) => {
	switch (action.kind) {
		case 'try-in-project':
			return <TryInProjectAction label={action.label} prompt={action.prompt} />;
		// DEPRECATED: superseded by export-ds-ai; rendered only for old chat messages.
		case 'download-ds':
			return <DownloadDsAction format={action.format} label={action.label} />;
		case 'show':
			return <ShowAction path={action.path} />;
		case 'generate-gallery':
			return <GenerateGalleryAction label={action.label} prompt={action.prompt} />;
		case 'connect-figma':
			return <ConnectFigmaAction label={action.label} />;
		case 'reconnect-figma':
			return <ReconnectFigmaAction label={action.label} />;
		case 'connect-github':
			return <ConnectGithubAction label={action.label} />;
		case 'new-chat':
			return <NewChatAction />;
		case 'publish':
			return <PublishAction />;
		case 'discard-changes':
			return <DiscardChangesAction />;
		case 'restore-version':
			return <RestoreVersionAction versionNumber={action.versionNumber} />;
		case 'switch-to-latest':
			return <SwitchToLatestAction />;
		case 'export-ds-ai':
			return (
				<ExportDsAiAction
					label={action.label}
					preset={action.preset}
					componentNames={action.componentNames}
					tokenDomains={action.tokenDomains}
					customPrompt={action.customPrompt}
				/>
			);
		case 'choice':
			return <ChoiceAction options={action.options} chatType="ds" />;
		default:
			return null;
	}
};

export default DsActionCard;
